import React, { PropTypes } from 'react';

const { array, func, number, string } = PropTypes;

const PlanSelector = ({ plans, selectedPlanIndex, onPlanClick }) => {
  return (
    <div style={{ backgroundColor: '#f5f5f5', margin: '0 auto', width: '40%', textAlign: 'center', padding: '5px', border: '1px solid #eeeeee', borderRadius: '3px', marginBottom: '10px' }}>
      { plans.map((plan, i) => {
        const selectedStyle = {
          backgroundColor: 'rgba(0,0,0,.1)',
          color: 'rgb(255, 39, 104)',
          fontWeight: 500,
        };

        return (
          <a
            key={i}
            onClick={
              () => onPlanClick(i)
            }
            style={
              Object.assign(
                {},
                {
                  display: 'inline-block',
                  fontSize: '18px',
                  lineHeight: '24px',
                  fontVariant: 'small-caps',
                  padding: '10px 20px',
                  width: '50%',
                  borderRadius: '5px',
                  cursor: 'pointer',
                },
                (selectedPlanIndex === i ? selectedStyle : {})
              )}
          >
            {plan.name}
          </a>
        );
      })
    }
  </div>
  );
};

PlanSelector.propTypes = {
  plans: array,
  planName: string,
  selectedPlanIndex: number,
  onPlanClick: func,
};

export default PlanSelector;



// WEBPACK FOOTER //
// ./src/app/components/upgrade/PlanSelector.jsx